module.exports = __webpack_public_path__ + "2a734d48e117d73c74790159fcbad5b8.jpg";